export const SET = 'Analysis/data/excludings/SET';

export function setExcludings(excludings) {
  return {
    type: SET,
    excludings
  }
}